
import { timeRangeOptions } from "@/utils/options";

export default (typeOption = []) => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '国家店铺',
    prop: 'countryMarket',
    components: [{
        name: 'gj-country-server-select',
        prop: 'countryMarket'
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: {
        countryIds: [],
        marketIds: []
    }
},{
    label: '类型',
    prop: 'type',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'type',
        propsData: {
            options: typeOption,
            placeholder: '类型'
        }
    }],
    defaultValue: ''
}, {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}]
